<template>
	<section v-if="title || subtitle" class="hero is-light">
		<div class="hero-body">
			<div class="container">
				<h1 v-if="title" class="title" v-text="title"></h1>
				<h2 v-if="subtitle" class="subtitle" v-text="subtitle"></h2>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "AppHeader",
	props: {
		title: {
			type: String,
			default: () => null
		},
		subtitle: {
			type: String,
			default: () => null
		}
	}
};
</script>
